module.exports = __webpack_public_path__ + "img/loan.53c1a771.svg";